import { getHomeHostHint } from '#pplx/frontend/apps/ask/auth/homeHostHint.js';
import { redirectToHomeHostBeforeBoot } from '#pplx/frontend/apps/ask/auth/redirectToHomeHostBeforeBoot.js';
import { canRedirectToHomeHostFrom } from '#pplx/frontend/apps/ask/auth/resolveHomeHostRedirect.js';
import { bootstrapState } from '#pplx/frontend/apps/ask/spa/resolveSpaBootstrapState.js';
import { getWindowOrigin } from '#pplx/frontend/common/location.js';
import { preloadClientTranslations } from '#pplx/frontend/i18n/clientTranslations.js';
import { LOCALE_TRANSLATIONS } from '#pplx_generated/pplx/frontend/apps/ask/spa/localeTranslations.generated.js';
function runStartup({ preload, boot }) {
    preload?.();
    boot();
}
/**
 * Owns the SPA startup sequence. On production consumer origins, routing waits
 * for the resolved session when the cache is missing or home-host routing is
 * plausible. A known cached consumer session keeps startup synchronous.
 */
export function startSpa(startup) {
    // The shell renders nothing for a non-default locale until its messages load, and no route
    // depends on the session to pick them, so start the load before any session gate.
    preloadClientTranslations(LOCALE_TRANSLATIONS);
    if (!canRedirectToHomeHostFrom(getWindowOrigin({ intent: 'document' }))) {
        runStartup(startup);
        return;
    }
    const { cachedSession, sessionFetchPromise } = bootstrapState;
    if (cachedSession && !cachedSession.user.home_host && !getHomeHostHint()) {
        runStartup(startup);
        return;
    }
    void sessionFetchPromise.then((session) => {
        if (!redirectToHomeHostBeforeBoot(session)) {
            runStartup(startup);
        }
    }, () => runStartup(startup));
}
//# sourceMappingURL=startSpa.js.map